import angular from 'angular'
import 'angular-carousel'
import 'angular-touch'
import 'angular-carousel/dist/angular-carousel.css'

import component from './carousel.component'

let module = angular.module('carousel', [
  'angular-carousel'
])

.component('carousel', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/catalog/components/carousel/index.js